<template>
  <transition name="s-zoom-in-top">
    <div
      v-show="show">
      <div
        class="error-banner">
        <sIcon
          class="my-auto"
          color="black"
          type="alert-outline"/>
        <transition-group
          appear
          class="error-banner_message"
          name="s-zoom-in-top"
          tag="div">
          <span
            v-if="loading"
            key="text-loading">
            {{ $t('Common.errorSignalTitle') }}
          </span>
          <span
            v-else
            key="text">
            {{ $t('Common.errorSignalContent') }}
          </span>
          <sButton
            v-if="!loading"
            key="btn-repeat"
            color="black"
            :disabled="loading"
            small
            type="text"
            @click="refreshSignal">
            {{ $t('Purchasing.Repeat') }}
          </sButton>
          <sButton
            v-if="!loading"
            key="btn-later"
            color="black"
            :disabled="loading"
            small
            type="text"
            @click="needRefreshPage(false)">
            {{ $t('Common.later') }}
          </sButton>
        </transition-group>
        <sButton
          color="black"
          icon="cross"
          small
          type="text"
          @click="needRefreshPage(false)"/>
      </div>
      <sProgress
        v-if="progressPercent || loading"
        :key="`percent-${progressPercent}`"
        class="error-banner-progress"
        stroke-linecap="square"
        :value="progressPercent"/>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'BannerSignalReconnect',
  data() {
    return {
      show: false,
      loading: false,

      currentDuration: 10000,
      progressPercent: 0,
      closeTimer: null,
    }
  },
  methods: {
    async refreshSignal() {
      this.startTimer()
      await this.$notifier.checHub()
    },
    needRefreshPage(state) {
      if (!this.growthBook.hide_sinal_info) {
        this.loading = false
        this.show = state
        this.clearCloseTimer()
      }
    },
    clearCloseTimer() {
      clearInterval(this.closeTimer)
      if (this.closeTimer) {
        this.currentDuration = 0
        this.progressPercent = 0
        clearTimeout(this.closeTimer)
        this.closeTimer = null
      }
    },
    startTimer() {
      this.loading = true
      this.currentDuration = 10000
      this.closeTimer = setInterval(() => {
        this.currentDuration -= 10
        this.progressPercent = (this.currentDuration * 100) / 10000
        if (this.currentDuration <= 10) { this.needRefreshPage(true) }
      }, 10)
    },
    showSignalAlert(key) {
      if (this.$notice.instances.find(i => i.id === 'signal-alert')) {
        this.$notice.closeById('signal-alert')
        return
      }
      this.$log_error('showSignalAlert', key)
      this.$notice.warning({
        id: 'signal-alert',
        title: this.isNotProduction ? key : null,
        message: this.$t('Common.errorSignalMessage'),
        dangerouslyUseHTMLString: true,
        duration: 10,
        loading: false,
        showClose: true,
        closeText: this.$t('Common.Close'),
      })
    },
  },
  mounted() {
    this.$root.$on('ShowSignalErrorReconnecting', this.needRefreshPage)
    this.$root.$on('ShowSignalAlert', this.showSignalAlert)
  },
  beforeDestroy() {
    this.$root.$off('ShowSignalErrorReconnecting', this.needRefreshPage)
    this.$root.$off('ShowSignalAlert', this.showSignalAlert)
  },
  props: {},
}
</script>
<style lang="scss" scoped>
.error-banner {
  display: grid;
  grid-template-columns: 30px auto 30px;
  padding: 3px 10px;
  background: #ffb36f;
  position: sticky;
  top: 0;
  color: black;

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1024;
  &_message {
    gap: 5px;
    display: flex;
    margin: 0 auto;
    & span {
      font-size: 14px;
      margin: auto 0;
      color: black;
    }
    & .s-btn {
      padding: 0 2px;
      text-decoration: underline;
      text-transform: none;
      font-size: 14px;
      margin: auto 0;
    }
  }
  &-progress {
    z-index: 1025;
    position: absolute;
    top: -2px;
    left: 0;
    right: 0;
  }
}
</style>
